import { Inline, Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";

import { ActivityHistoryFooter } from "./activity_history_footer";
import css from "./activity_history_tab.module.scss";
import { ActivityHistoryContextProvider } from "./context";
import { useHistoryTabEvents } from "./hooks/use_history_tab_events";
import { HistoryEmptyState, HistoryEntriesList, HistoryFiltersTile, HistorySort } from "./parts";

const ActivityHistoryTabContent = () => {
  const { error, isLoading, data } = useHistoryTabEvents();

  const isUnauthorized = error?.response?.status === 422;
  const isEmpty = isLoading || isUnauthorized || !data?.entries.length;

  return (
    <Inline gap="spacingLg" alignItems="start">
      {!!data && <HistoryFiltersTile />}
      <Stack gap="spacingLg" className={css.content}>
        {!!data?.entries.length && <HistorySort />}
        {isEmpty ? (
          <HistoryEmptyState />
        ) : (
          <Tile variant="light" paddingVariant="xl">
            <HistoryEntriesList />
            <ActivityHistoryFooter />
          </Tile>
        )}
      </Stack>
    </Inline>
  );
};

export const ActivityHistoryTab = () => (
  <ActivityHistoryContextProvider>
    <ActivityHistoryTabContent />
  </ActivityHistoryContextProvider>
);
